import { useEffect, useState, useContext } from "react";
import { LocalStoreContext } from "../store/LocalStore";
import { RefContext } from "../store/RefContext";

const headerStyle = {
  fontSize: 10,
  fontWeight: 600,
  paddingLeft: 20,
  paddingRight: 20,
  textAlign: "center",
};
const vectorColumnStyle = { fontSize: 10, fontWeight: 600 };
const contentStyle = { fontSize: 10, fontWeight: 400, textAlign: "center" };

const vecOrder = [
  "99U",
  "95U",
  "EUB",
  "EDB",
  "95D",
  "99D",
  "Sigma_99U",
  "Sigma_95U",
  "Sigma_95D",
  "Sigma_99D",
];

export const TableView = () => {
  const [lstore] = useContext(LocalStoreContext);
  const refs = useContext(RefContext);
  const { strengthData, tableViewSelectedKey } = lstore;

  const [filteredData, setFilteredData] = useState();
  useEffect(() => {
    if (strengthData) {
      const filteredDataNew = strengthData
        .filter((item) => {
          return item.vSet.slice(0, 2) !== "vs";
        })
        .sort((a, b) => {
          return vecOrder.indexOf(a.vec) > vecOrder.indexOf(b.vec)
            ? 1
            : vecOrder.indexOf(a.vec) < vecOrder.indexOf(b.vec)
            ? -1
            : 0;
        });
      setFilteredData(filteredDataNew);
    }
  }, [strengthData]);

  return filteredData ? (
    <div
      style={{
        height: refs.componentSize.current["TableView"].height,
        width: refs.componentSize.current["TableView"].width - 17,
        margin: 0,
        display: "block",
      }}
    >
      <table>
        <thead
          onClick={() => {
            return refs.saveLayoutRef.current();
          }}
        >
          <tr>
            <td></td>
            {filteredData[0].values.map((item, i) => {
              return (
                <td key={i} style={headerStyle}>
                  {formatDate(item.date)}
                </td>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, i) => {
            return (
              <tr key={"b" + i}>
                <td style={vectorColumnStyle}>{row.vec}</td>
                {row.values.map((val, i) => {
                  return (
                    <td key={"v" + i} style={contentStyle}>
                      {val[tableViewSelectedKey]}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  ) : null;
};

// const formatTime = d3.timeFormat("%m/%d/%Y");

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}
function formatDate(date) {
  return [
    padTo2Digits(date.getMonth() + 1),
    padTo2Digits(date.getDate()),
    date.getFullYear() % 100,
  ].join("/");
}
